import { BaseService } from 'core/services';
import NikoPatientTemplateItemRouteService from './NikoPatientTemplateItemRouteService';

class NikoPatientTemplateItemService extends BaseService {
  constructor(apiClient) {
    super(apiClient, new NikoPatientTemplateItemRouteService());
  }

  create(resource) {
    const connectionId = sessionStorage.getItem("connectionId");
    return this.apiClient.post(this.routeService.create(), resource, connectionId ? { connectionId: connectionId } : null);
  }

  update(id, resource) {
    const connectionId = sessionStorage.getItem("connectionId");
    return this.apiClient.put(this.routeService.update(id), resource, connectionId ? { connectionId: connectionId } : null);
  }

  delete(id, resource) {
    const connectionId = sessionStorage.getItem("connectionId");
    return this.apiClient.delete(this.routeService.delete(id), connectionId ? { connectionId: connectionId } : null, resource);
  }

  put(url, resource) {
    const connectionId = sessionStorage.getItem("connectionId");
    return this.apiClient.put(url, resource, connectionId ? { connectionId: connectionId } : null);
  }

  calculateQuantity(resource) {
    const url = this.routeService.calculateQuantity(resource);
    return this.apiClient.put(url, resource);
  }

  createAdditionalItems(resource) {
    const url = this.routeService.createAdditionalItems(resource);
    return this.apiClient.post(url, resource);
  }

  createAdditionalTrachItems(resource) {
    const url = this.routeService.createAdditionalTrachItems(resource);
    return this.apiClient.post(url, resource);
  }

  findAndReplaceItem(resource){
    const url = this.routeService.findAndReplaceItem(resource);
    return this.put(url, resource);
  }

  calculateReplacementItemsQuantity(resources){
    const url = this.routeService.calculateReplacementItemsQuantity(resources);
    return this.put(url, resources)
  }

  findAndDeleteItem(resource){
    const url = this.routeService.findAndDeleteItem(resource);
    return this.put(url, resource);
  }

  getNikoOrderSummaryItems(filter) {
    const url = this.routeService.getNikoOrderSummaryItems(filter);
    return this.apiClient.get(url);
  }

  nikoCutbackSalesOrderQuantities(resource) {
    const url = this.routeService.nikoCutbackSalesOrderQuantities(resource);
    return this.put(url, resource);
  }

  nikoUpdateSendSeparatelyQuantity(resource) {
    const url = this.routeService.nikoUpdateSendSeparatelyQuantity(resource);
    return this.put(url, resource);
  }

  nikoUpdateBatchSendSeparatelyQuantity(resource) {
    const url = this.routeService.nikoUpdateBatchSendSeparatelyQuantity(resource);
    return this.put(url, resource);
  }

  nikoRoundToTheNearestCase(resource) {
    const url = this.routeService.nikoRoundToTheNearestCase(resource);
    return this.put(url, resource);
  }
}

export default NikoPatientTemplateItemService;
